import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-employment-verification-form',
  templateUrl: './employment-verification-form.component.html',
  styleUrls: ['./employment-verification-form.component.css']
})
export class EmploymentVerificationFormComponent implements OnInit {

  @Input() candidateDetails: any;
    @Input() questions: any;
  @Input() uniqueCode: any;
  @Input() formData: any = {};


  @Output() onNext  = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

setCurrentEmploymentDate() {
  if (this.formData.q4CurrentlyEmployed) {
    // Auto-fill with today’s date
    this.formData.q4EndDate = new Date().toISOString().substring(0, 10);
  } else {
    // Clear end date if unchecked
    this.formData.q4EndDate = '';
  }
}

submitForm() {
    if (!this.isFormValid()) {
    return;
  }
  else
  {
  const payload = this.questions.map(q => {
    let selectedAnswer = this.formData[q.questionId] || '';
    let additionalComments = '';
    let dynamicValue = '';

    // Special cases
    if (q.questionNumber === 3 && selectedAnswer.startsWith('No')) {
      dynamicValue = this.formData[q.questionId + 'CorrectText'] || '';
    }

    if (q.questionNumber === 4 && selectedAnswer === 'No, please correct') {
      dynamicValue = `${this.formData.q4StartDate || ''} - ${this.formData.q4EndDate || ''}`;
      if (this.formData.q4CurrentlyEmployed) {
        dynamicValue += ' (Currently Employed)';
      }
    }

    if (q.questionNumber >= 7 && q.questionNumber <= 9) {
      additionalComments = this.formData[q.questionId + 'Comments'] || '';
    }

  if (q.questionNumber === 11) {
  selectedAnswer = this.formData.q11Confirm ? 'Yes, I confirm' : 'No';

  // Always ensure dateOfCompletion has a value
  const completionDate = this.formData.dateOfCompletion || new Date().toISOString().substring(0, 10);

  dynamicValue = `Signature: ${this.formData.signature || ''}, Date: ${completionDate}`;
}

    return {
      uniqueCode: this.uniqueCode, // or generate dynamically
      questionId: q.questionId,
      selectedAnswer,
      additionalComments,
      dynamicValue,
      // ✅ force final submission true for Q11
      isFinalSubmission: q.questionNumber === 11 ? true : false
    };
  });
console.log('load',payload);
  this.onNext.emit(payload);
}
}

isFormValid(): boolean {
  // If Q1 or Q2 are answered "No", allow submission immediately
  if ((this.formData[1] && this.formData[1].startsWith('No')) || this.formData[2] === 'No') {
    return true;
  }

  // Ensure Q1 and Q2 are answered
  const q1Answered = !!this.formData[1];
  const q2Answered = !!this.formData[2];

  // Require Q11 confirmation + signature for final submission
  const finalStepValid = this.formData.q11Confirm && !!this.formData.signature;

  return q1Answered && q2Answered && finalStepValid;
}

}
